/** React helpers over react-i18next. */
import { useTranslation } from 'react-i18next';

import type { LanguageCode } from '@/lib/preferences';

import { directionOf } from './index';

/** `t` for English-keyed strings. */
export function useT() {
  return useTranslation().t;
}

export function useLanguage(): LanguageCode {
  const { i18n } = useTranslation();
  const language = i18n.language;
  return language === 'sw' || language === 'ar' ? language : 'en';
}

/** Reading direction for Radix portals (they render outside <html dir> context). */
export function useDirection(): 'ltr' | 'rtl' {
  return directionOf(useLanguage());
}
